/** The booking page piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { BookingPageEvents } from './contract';
import { BookingPageView } from './BookingPageView';
import { useBookingPage } from './useBookingPage';

export { BookingPageView, useBookingPage };

export function BookingPage(props: PieceInput<BookingPageEvents>) {
  return <BookingPageView {...useBookingPage(props)} />;
}
